// icones
import { AiFillDashboard, AiFillHome } from "react-icons/ai";
import {
  MdOutlineAutorenew,
  MdOutlineLocationCity,
} from "react-icons/md";
import {
  FaUsers,
  FaHandshake,
  FaBriefcase,
  FaTasks,
  FaList,
  FaBalanceScale,
  FaFileInvoice,
} from "react-icons/fa";
import { HiDesktopComputer, HiLocationMarker } from "react-icons/hi";
import { GiOpenFolder } from "react-icons/gi";

// composants
import UserHome from "./views/user/UserHome";
import Procedures from "./views/user/Procedures";
import UserDomiciliation from "./views/user/UserDomiciliation";
import UserPlatformAdmin from "./views/user/UserPlatformAdmin";
import UserPlatformGRH from "./views/user/UserPlatformGRH";
import UserPlatformSale from "./views/user/userPlatformSale/UserPlatformSale";
import UserPlatformJuridique from "./views/user/UserPlatformJuridique";
import OperatorHome from "./views/operator/OperatorHome";
import OperatorDomiciliation from "./views/operator/OperatorDomiciliation";
import OperatorPlatformAdmin from "./views/operator/OperatorPlatformAdmin";
import OperatorPlatformGRH from "./views/operator/OperatorPlatformGRH";
import OperatorPlatformSale from "./views/operator/OperatorPlatformSale";
import OperatorPlatformJuridique from "./views/operator/OperatorPlatformJuridique";
import OperatorProcedures from "./views/operator/operatorProcedures/OperatorProcedures";
import AdminHome from "./views/admin/AdminHome";
import AdminProcedures from "./views/admin/AdminProcedures";
import AdminDomiciliation from "./views/admin/AdminDomiciliation";
import AdminPlatformAdmin from "./views/admin/AdminPlatformAdmin";
import AdminPlatformGRH from "./views/admin/AdminPlatformGRH";
import AdminPlatformSale from "./views/admin/AdminPlatformSale";
import AdminPlatformJuridique from "./views/admin/AdminPlatformJuridique";
import Statistics from "./views/admin/Statistics";
import Operators from "./views/admin/Operators";
import { IoBarChart } from "react-icons/io5";
import MyDocuments from "./views/user/MyDocuments";
import { BsBuildingFill, BsPerson } from "react-icons/bs";
import {
  RiCustomerService2Fill,
  RiListView,
  RiMoneyDollarBoxLine,
  RiProfileFill,
} from "react-icons/ri";
import AdminCompanies from "./views/admin/AdminCompanies";
import AdminSubscriptions from "./views/admin/AdminSubscriptions";
import AdminCustomers from "./views/admin/AdminCustomers";
import BusinessCreationDetails from "./views/operator/operatorProcedures/BusinessCreationDetails";
import UserProfile from "./views/user/UserProfile";
import NewSubscription from "./views/user/NewSubscription";
import Subscriptions from "./views/user/Subscriptions";
import UserPlatformSaleTicket from "./views/user/userPlatformSale/UserPlatformSaleTicket";
import UserPlatformGest from "./views/user/UserPlatformGest/UserPlatformGest";
import UserPlatformGestTicket from "./views/user/UserPlatformGest/UserPlatformGestTicket";
import OperatorPlatformGest from "./views/operator/OperatorPlatformGest";
import AdminPlatformGest from "./views/admin/AdminPlatformGest";
import OperatorTicketDetails from "./views/operator/OperatorTicketDetails";
import OperatorCompanies from "./views/operator/OperatorCompanies";
import OperatorSubscriptions from "./views/operator/OperatorSubscriptions";
import Services from "./views/admin/Services";
import UserTransactionHistory from "./views/user/UserTransactionHistory";
import TransactionHistory from "./views/admin/TransactionHistory";
import ServiceRequestDetails from "./views/operator/operatorProcedures/ServiceRequestDetails";
import OperatorOdoo from "./views/operator/OperatorOdoo";
import CriminalRecordDetails from "./views/operator/operatorProcedures/CriminalRecordDetails";
import CertificateSinglenessDetails from "./views/operator/operatorProcedures/CertificateSinglenessDetails";
import CertificateNationalityDetails from "./views/operator/operatorProcedures/CertificateNationalityDetails";
import EneoDetails from "./views/operator/operatorProcedures/EneoDetails";
import CustomsRebateDetails from "./views/operator/operatorProcedures/CustomsRebateDetails";
import OperatorRequestDetails from "./views/operator/operatorProcedures/OperatorRequestDetails";
import BusinessPlanDetails from "./views/operator/operatorProcedures/BusinessPlanDetails";
import ImportationDetails from "./views/operator/operatorProcedures/ImportationDetails";
import OapiDetails from "./views/operator/operatorProcedures/OapiDetails";
import PassportDetails from "./views/operator/operatorProcedures/PassportDetails";
import SalesProcedures from "./views/sales/SalesProcedures";
import SalesSubscriptions from "./views/sales/SalesSubscriptions";
import Sales from "./views/admin/Sales";
import FollowUpDetails from "./views/sales/FollowUpDetails";

const routes = [
  //User routes
  {
    path: "/home",
    name: "Accueil",
    component: UserHome,
    icon: <AiFillHome size={24} />,
    layout: "/user",
    isVisible: true,
  },
  {
    path: "/procedures",
    name: "Mes démarches",
    component: Procedures,
    icon: <FaTasks size={24} />,
    layout: "/user",
    isVisible: true,
  },
  {
    path: "/domiciliation",
    name: "Domiciliation",
    component: UserDomiciliation,
    icon: <HiLocationMarker size={24} />,
    layout: "/user",
    group: "Mes services",
    requiresCompany: true,
    isVisible: true,
  },
  {
    path: "/platformAdmin",
    name: "Administration",
    component: UserPlatformAdmin,
    icon: <MdOutlineLocationCity size={24} />,
    layout: "/user",
    group: "Mes services",
    requiresCompany: true,
    isVisible: true,
  },
  {
    path: "/platformGest",
    name: "Facturation",
    component: UserPlatformGest,
    icon: <FaFileInvoice size={24} />,
    layout: "/user",
    group: "Mes services",
    subgroup: "Gestion 360",
    requiresCompany: true,
    isVisible: true,
  },
  {
    path: "/platformGest-tickets",
    name: "FacturationTickets",
    component: UserPlatformGestTicket,
    icon: <FaBriefcase size={24} />,
    layout: "/user",
    isVisible: false,
  },

  {
    path: "/platformGRH",
    name: "Ressources humaines",
    component: UserPlatformGRH,
    icon: <FaUsers size={24} />,
    layout: "/user",
    group: "Mes services",
    subgroup: "Gestion 360",
    requiresCompany: true,
    isVisible: true,
  },
  {
    path: "/platformSales",
    name: "Relation client",
    component: UserPlatformSale,
    icon: <FaHandshake size={24} />,
    layout: "/user",
    group: "Mes services",
    subgroup: "Gestion 360",
    requiresCompany: true,
    isVisible: true,
  },
  {
    path: "/platformSales-tickets",
    name: "platformSalesTickets",
    component: UserPlatformSaleTicket,
    icon: <MdOutlineLocationCity size={24} />,
    layout: "/user",
    isVisible: false,
  },
  {
    path: "/platformJuridique",
    name: "Suivi juridique",
    icon: <FaBalanceScale size={24} />,
    component: UserPlatformJuridique,
    layout: "/user",
    group: "Mes services",
    requiresCompany: true,
    isVisible: true,
  },
  {
    path: "/mydocuments",
    name: "Mes documents",
    icon: <GiOpenFolder size={24} />,
    component: MyDocuments,
    layout: "/user",
    isVisible: false,
  },
  {
    path: "/profile",
    name: "Profile",
    icon: <GiOpenFolder size={24} />,
    component: UserProfile,
    layout: "/user",
    isVisible: false,
  },
  {
    path: "/subscriptions",
    name: "Abonnements",
    icon: <GiOpenFolder size={24} />,
    component: Subscriptions,
    layout: "/user",
    isVisible: false,
  },
  {
    path: "/new-subscription",
    name: "NewSubscriptions",
    icon: <GiOpenFolder size={24} />,
    component: NewSubscription,
    layout: "/user",
    isVisible: false,
  },
  {
    path: "/transaction-history",
    name: "Paiements",
    icon: <FaList size={24} />,
    component: UserTransactionHistory,
    layout: "/user",
    isVisible: false,
  },

  //Operator routes
  {
    path: "/home",
    name: "Tableau de bord",
    component: OperatorHome,
    icon: <AiFillDashboard size={24} />,
    layout: "/operator",
    isVisible: true,
  },
  // {
  //   path: "/customers",
  //   name: "Clients",
  //   component: OperatorCustomers,
  //   icon: <FaUsers size={24} />,
  //   layout: "/operator",
  //   isVisible: true,
  // },
  {
    path: "/procedures",
    name: "Démarches clients",
    component: OperatorProcedures,
    icon: <FaTasks size={24} />,
    layout: "/operator",
    group: "Suivi",
    isVisible: true,
  },
  {
    path: "/companies",
    name: "Entreprises",
    component: OperatorCompanies,
    icon: <BsBuildingFill size={24} />,
    layout: "/operator",
    group: "Suivi",
    isVisible: true,
  },
  {
    path: "/subscriptions",
    name: "Abonnements",
    component: OperatorSubscriptions,
    icon: <MdOutlineAutorenew size={24} />,
    layout: "/operator",
    group: "Suivi",
    isVisible: true,
  },
  {
    path: "/domiciliation",
    name: "Domiciliation",
    component: OperatorDomiciliation,
    icon: <HiLocationMarker size={24} />,
    layout: "/operator",
    group: "Services",
    isVisible: true,
  },
  {
    path: "/platformGest",
    name: "Facturation",
    component: OperatorPlatformGest,
    icon: <FaFileInvoice size={24} />,
    layout: "/operator",
    group: "Services",
    subgroup: "Gestion 360",
    isVisible: true,
  },
  {
    path: "/platformAdmin",
    name: "Administration",
    component: OperatorPlatformAdmin,
    icon: <MdOutlineLocationCity size={24} />,
    layout: "/operator",
    group: "Services",
    isVisible: true,
  },
  {
    path: "/platformGRH",
    name: "Ressources humaines",
    component: OperatorPlatformGRH,
    icon: <FaUsers size={24} />,
    layout: "/operator",
    group: "Services",
    subgroup: "Gestion 360",
    isVisible: true,
  },
  {
    path: "/platformSale",
    name: "Relation client",
    component: OperatorPlatformSale,
    icon: <FaHandshake size={24} />,
    layout: "/operator",
    group: "Services",
    subgroup: "Gestion 360",
    isVisible: true,
  },
  {
    path: "/odoo-tickets",
    name: "Comptes ERP",
    component: OperatorOdoo,
    icon: <HiDesktopComputer size={24} />,
    layout: "/operator",
    group: "Services",
    subgroup: "Gestion 360",
    isVisible: true,
  },
  {
    path: "/platformJuridique",
    name: "Suivi juridique",
    icon: <FaBalanceScale size={24} />,
    component: OperatorPlatformJuridique,
    layout: "/operator",
    group: "Services",
    isVisible: true,
  },
  {
    path: "/business-creation-detail",
    name: "BusinessCreationDetail",
    icon: <FaBalanceScale size={24} />,
    component: BusinessCreationDetails,
    layout: "/operator",
    isVisible: false,
  },
  {
    path: "/service-request-detail",
    name: "ServiceRequestDetail",
    icon: <FaBalanceScale size={24} />,
    component: ServiceRequestDetails,
    layout: "/operator",
    isVisible: false,
  },
  {
    path: "/criminal-record-detail",
    name: "ServiceRequestDetail",
    icon: <FaBalanceScale size={24} />,
    component: CriminalRecordDetails,
    layout: "/operator",
    isVisible: false,
  },
  {
    path: "/certificate-singleness-detail",
    name: "CertificateSinglenessDetails",
    icon: <FaBalanceScale size={24} />,
    component: CertificateSinglenessDetails,
    layout: "/operator",
    isVisible: false,
  },
  {
    path: "/certificate-nationality-detail",
    name: "CertificateNationalityDetails",
    icon: <FaBalanceScale size={24} />,
    component: CertificateNationalityDetails,
    layout: "/operator",
    isVisible: false,
  },
  {
    path: "/passport-detail",
    name: "PassportDetails",
    icon: <FaBalanceScale size={24} />,
    component: PassportDetails,
    layout: "/operator",
    isVisible: false,
  },
  {
    path: "/eneo-detail",
    name: "EneoDetails",
    icon: <FaBalanceScale size={24} />,
    component: EneoDetails,
    layout: "/operator",
    isVisible: false,
  },
  {
    path: "/customs-rebate-detail",
    name: "CustomRebateDetails",
    icon: <FaBalanceScale size={24} />,
    component: CustomsRebateDetails,
    layout: "/operator",
    isVisible: false,
  },
  {
    path: "/visual-identity-detail",
    name: "VisualIdentityDetails",
    component: OperatorRequestDetails,
    layout: "/operator",
    isVisible: false,
  },
  {
    path: "/formality-detail",
    name: "FormalityDetails",
    component: OperatorRequestDetails,
    layout: "/operator",
    isVisible: false,
  },
  {
    path: "/business-plan-detail",
    name: "BusinessPlanDetails",
    icon: <FaBalanceScale size={24} />,
    component: BusinessPlanDetails,
    layout: "/operator",
    isVisible: false,
  },
  {
    path: "/importation-detail",
    name: "ImportationDetails",
    icon: <FaBalanceScale size={24} />,
    component: ImportationDetails,
    layout: "/operator",
    isVisible: false,
  },
  {
    path: "/oapi-detail",
    name: "OapiDetails",
    icon: <FaBalanceScale size={24} />,
    component: OapiDetails,
    layout: "/operator",
    isVisible: false,
  },
  // {
  //   path: "/documents",
  //   name: "Documents",
  //   icon: <GiOpenFolder size={24} />,
  //   component: MyDocuments,
  //   layout: "/operator",
  //   isVisible: true,
  // },
  {
    path: "/ticket-details",
    name: "Ticket details",
    icon: <GiOpenFolder size={24} />,
    component: OperatorTicketDetails,
    layout: "/operator",
    isVisible: false,
  },

  //Admin routes
  {
    path: "/home",
    name: "Tableau de bord",
    component: AdminHome,
    icon: <AiFillDashboard size={24} />,
    layout: "/admin",
    group: "Pilotage",
    isVisible: true,
  },
  {
    path: "/statistics",
    name: "Statistiques",
    component: Statistics,
    icon: <IoBarChart size={24} />,
    layout: "/admin",
    group: "Pilotage",
    isVisible: true,
  },
  {
    path: "/procedures",
    name: "Démarches clients",
    component: AdminProcedures,
    icon: <FaTasks size={24} />,
    layout: "/admin",
    group: "Clients",
    isVisible: true,
  },
  {
    path: "/customers",
    name: "Clients",
    component: AdminCustomers,
    icon: <FaUsers size={24} />,
    layout: "/admin",
    group: "Clients",
    isVisible: true,
  },
  {
    path: "/companies",
    name: "Entreprises",
    component: AdminCompanies,
    icon: <BsBuildingFill size={24} />,
    layout: "/admin",
    group: "Clients",
    isVisible: true,
  },
  {
    path: "/subscriptions",
    name: "Abonnements",
    component: AdminSubscriptions,
    icon: <MdOutlineAutorenew size={24} />,
    layout: "/admin",
    group: "Clients",
    isVisible: true,
  },
  {
    path: "/operators",
    name: "Opérateurs",
    component: Operators,
    icon: <RiCustomerService2Fill size={24} />,
    layout: "/admin",
    group: "Équipe",
    isVisible: true,
  },
  {
    path: "/sales",
    name: "Commerciaux",
    component: Sales,
    icon: <BsPerson size={24} />,
    layout: "/admin",
    group: "Équipe",
    isVisible: true,
  },
  {
    path: "/transaction-history",
    name: "Transactions",
    icon: <RiMoneyDollarBoxLine size={24} />,
    component: TransactionHistory,
    layout: "/admin",
    group: "Pilotage",
    isVisible: true,
  },
  {
    path: "/domiciliation",
    name: "Domiciliation",
    component: AdminDomiciliation,
    icon: <HiLocationMarker size={24} />,
    layout: "/admin",
    group: "Services",
    isVisible: true,
  },
  {
    path: "/platformGest",
    name: "Facturation",
    component: AdminPlatformGest,
    icon: <FaFileInvoice size={24} />,
    layout: "/admin",
    group: "Services",
    subgroup: "Gestion 360",
    isVisible: true,
  },
  {
    path: "/platformAdmin",
    name: "Administration",
    component: AdminPlatformAdmin,
    icon: <MdOutlineLocationCity size={24} />,
    layout: "/admin",
    group: "Services",
    isVisible: true,
  },
  {
    path: "/platformGRH",
    name: "Ressources humaines",
    component: AdminPlatformGRH,
    icon: <FaUsers size={24} />,
    layout: "/admin",
    group: "Services",
    subgroup: "Gestion 360",
    isVisible: true,
  },
  {
    path: "/platformSale",
    name: "Relation client",
    component: AdminPlatformSale,
    icon: <FaHandshake size={24} />,
    layout: "/admin",
    group: "Services",
    subgroup: "Gestion 360",
    isVisible: true,
  },
  {
    path: "/platformJuridique",
    name: "Suivi juridique",
    icon: <FaBalanceScale size={24} />,
    component: AdminPlatformJuridique,
    layout: "/admin",
    group: "Services",
    isVisible: true,
  },
  {
    path: "/services",
    name: "Catalogue des services",
    component: Services,
    icon: <RiListView size={24} />,
    layout: "/admin",
    group: "Paramètres",
    isVisible: true,
  },

  //sales routes
  {
    path: "/home",
    name: "Démarches inachevées",
    component: SalesProcedures,
    icon: <FaTasks size={24} />,
    layout: "/sales",
    isVisible: true,
  },
  {
    path: "/subscriptions",
    name: "Abonnements",
    component: SalesSubscriptions,
    icon: <MdOutlineAutorenew size={24} />,
    layout: "/sales",
    isVisible: true,
  },
  {
    path: "/follow-up-details",
    name: "follow-up details",
    component: FollowUpDetails,
    icon: <FaTasks size={24} />,
    layout: "/sales",
    isVisible: false,
  },
];

export default routes;
